export default __webpack_public_path__ + "static/media/SWT1370.34I-34999_-24497_0.a9f06b57.jpg";